// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"822fe483","463":"53780bdf","531":"76c04153","598":"53780bdf"}[chunkId] + ".chunk.css";
};